import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BrandingService, CompanyBranding } from 'common';
import { ForgotPasswordDialogModel } from '../../model/forgot-password.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifs-reset-token-sent-dialog',
    templateUrl: './reset-token-sent-dialog.component.html',
    standalone: false
})
export class ResetTokenSentDialogComponent {
  email: string;
  noReplyEmail: string;

  constructor(
    public dialogRef: MatDialogRef<ResetTokenSentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ForgotPasswordDialogModel,
    private brandingService: BrandingService
  ) { }

  ngOnInit() {
    this.email = this.data.email;
    this.initBrandingInfo();
  }

  private initBrandingInfo(): void {
    this.brandingService.getBranding$()
      .pipe(untilDestroyed(this))
      .subscribe((branding: CompanyBranding) => {
        this.noReplyEmail = branding?.noReplyEmail ?? 'noreply@mail.ideafinancial.com';
      });
  }
}
